import React from 'react';
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import VisibilitySensorComponent from '../VisibilitySensorComponent';

interface Props {
  data: any;
}

const EduFairKcByNumber: React.FC<Props> = ({ data }: any) => {
  return (
    <div
      id='edu-fair-kcbynumber'
      className={styles.kcByNumber}
      style={{ background: data?.sectionBgColor || '#FFFFFF' }}
    >
      <Container>
        <div className={styles.number}>
          <Row>
            <div className={styles.heading}>
              <h2>{data?.coreTitle}</h2>
            </div>
          </Row>
          <Row>
            {data?.sections?.length > 0 &&
              data?.sections.map((section: any) => {
                return (
                  <Col xl={4} lg={4} md={4} sm={12}>
                    <div className={styles.box}>
                      <h3 style={{ color: section?.color }}>
                        <VisibilitySensorComponent
                          end={parseInt(
                            section?.countText.replace(/[,+Cr]/g, '')
                          )}
                          suffix={section?.countText.includes('Cr+') ? ' Cr+' : section?.countText.includes('+') ? '+' : ''}
                        ></VisibilitySensorComponent>
                      </h3>
                      <h4>{section?.sectionTitle}</h4>
                      <p>{section?.sectionDesc}</p>
                    </div>
                  </Col>
                );
              })}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default EduFairKcByNumber;
